import { makeStyles } from '@material-ui/core/styles';
import brandConstants from '../../../../../../common/bmw-dis.cl.latam.assets/constants/brandConstants';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';

export type CarCardStylesClasses =
  | 'carPricesContainer'
  | 'wrapper'
  | 'selectButtonWrapper'
  | 'cta'
  | 'learnMoreCta'
  | 'learnMoreCtaContainer'
  | 'learnMoreCtaLabel';

const carCardStyles = makeStyles<ISpcTheme, CarCardStylesClasses>(
  () => ({
    wrapper: {
      border: `1px solid ${brandConstants.COLOR_EIGHT}`,
    },
    carPricesContainer: {
      padding: '16px 0',
    },
    selectButtonWrapper: {
      marginTop: 'auto',
      padding: '16px 0 22px',
    },
    cta: {
      maxWidth: 180,
      borderRadius: 0,
    },
    learnMoreCtaContainer: {},
    learnMoreCtaLabel: {},
    learnMoreCta: {},
  }),
  { name: 'StockLite_CarCard' },
);

export default carCardStyles;
